import { useContext, useEffect, useState } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const TransparentSearchFilter = () => {
	const { searchInputRef, dictionaryWords } = useContext(ActivitiesContext);
	const [inputValue, setInputValue] = useState("");
	const label = dictionaryWords.keyword;

	const handleClear = () => {
		searchInputRef.current.value = "";
	}

	return (
		<div className="c-transparent-filter__input">			
			<div
				className='c-input c-input--full-width'>
				<input 
					ref={searchInputRef}
					placeholder= {label}
					id="search_filter"
					className="c-input__field" 
					type="text"
				>        
				</input>
				{label && <label htmlFor="input" className="c-input__label">{label}</label>}
				<div className="c-input__right">
					{searchInputRef.current.value === ''? (
						<i className="fal fa-search"></i>
					) : (
						<i onClick={handleClear} className="fal fa-times-circle"></i>
					)}
				</div>
			</div>
		</div>
	);
};

export default TransparentSearchFilter;
